import React, { useEffect, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import { isNativeApp, openPdfNatively } from '../../../lib/nativeDownload';

const PdfViewerDialog = ({ open, url, fileName, onClose }) => {
  const prevUrl = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const native = isNativeApp();

  useEffect(() => {
    return () => {
      if (prevUrl.current) {
        window.URL.revokeObjectURL(prevUrl.current);
        prevUrl.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!open && prevUrl.current) {
      window.URL.revokeObjectURL(prevUrl.current);
      prevUrl.current = null;
    }
    if (open && url) {
      prevUrl.current = url;
    }
  }, [open, url]);

  // 네이티브(Android) 앱: WebView가 PDF를 iframe으로 그리지 못해 Dialog가 빈 화면이 되므로,
  // 열리는 즉시 폰의 PDF 뷰어로 바로 열고 이 Dialog는 렌더링하지 않는다.
  useEffect(() => {
    if (!native || !open || !url) return;
    let cancelled = false;
    (async () => {
      try {
        await openPdfNatively(url, fileName || 'preview.pdf');
      } catch (e) {
        if (!cancelled) {
          enqueueSnackbar('PDF 미리보기 실패: ' + (e?.message || e), { variant: 'error' });
        }
      } finally {
        if (!cancelled) onClose?.();
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [native, open, url]);

  if (native) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <Typography variant="subtitle1" noWrap sx={{ maxWidth: '90%' }}>
          {fileName}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, height: '80vh' }}>
        {url && (
          <iframe
            src={url}
            title={fileName}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PdfViewerDialog;
